/* eslint-disable */
import React, { useContext } from 'react';
import { Data, Filters } from '../contexts';
import { calculateKFIMetric, MonthlyKFIsValues, KFIsCommonSizeArrows } from '../report_components/MoneyHelpers';
import { parseMoney } from '../../utils';

const getYTDMonthCount = (data, ytdMonths) => {
  if (!data || !Array.isArray(ytdMonths)) return 0;
  return ytdMonths.filter((m) => _.isNumber(data[m])).length;
};

const getYTDMonths = (data, ytdMonths) => {
  if (!data || !Array.isArray(ytdMonths)) return [];
  return ytdMonths.map((m) => data[m]);
};

const monthNames = {
  1: 'JAN',
  2: 'FEB',
  3: 'MAR',
  4: 'APR',
  5: 'MAY',
  6: 'JUN',
  7: 'JUL',
  8: 'AUG',
  9: 'SEP',
  10: 'OCT',
  11: 'NOV',
  12: 'DEC',
};

const MoneyYTDKFI = (props) => {
  const { monthly_calcs, ytd_months } = useContext(Data);
  const { filters } = useContext(Filters);
  let finalFilters = props.tabFilters || filters;
  let reportPeriod = finalFilters.report_period;
  const avgCalcs = props.aggregateData ? props.aggregateData?.monthly : monthly_calcs;
  const selectedYear = finalFilters.year;
  const previousYear = finalFilters.year - 1;
  const twoYearsAgo = finalFilters.year - 2;
  const selectedYearEndDigits = selectedYear ? selectedYear.toString().slice(-2) : '';
  const previousYearEndDigits = previousYear ? previousYear.toString().slice(-2) : '';
  let compareWith = finalFilters.compare_with;
  let isForecast = compareWith && compareWith.includes('Forecast')
  let numberCompare;
  if (filters && compareWith === 'Default:YOY') {
    numberCompare = 'n = 1'
  } else {
    numberCompare = `n = ${props.aggregateData?.monthly_avg_n?.[selectedYear] ?? 0}`;
  }

  let numberOfMonths = 0
  let useableMonths = monthly_calcs?.['you']?.['cash']?.[selectedYear] ? Object.values(monthly_calcs?.['you']?.['cash']?.[selectedYear]) : [];
  useableMonths.forEach(thing => thing !== null ? numberOfMonths += 1 : null)

  const youSelectedYearTotalRevenue = monthly_calcs?.you?.total_revenue?.[selectedYear];
  const youPreviousYearTotalRevenue = monthly_calcs?.you?.total_revenue?.[previousYear];

  const firstYearMonth = getYTDMonthCount(youPreviousYearTotalRevenue, ytd_months)
  const secondYearMonth = getYTDMonthCount(youSelectedYearTotalRevenue, ytd_months)
  const clientFirstYearMonth = firstYearMonth < 10 ? '0' + firstYearMonth.toString() : firstYearMonth;
  const clientSecondYearMonth = secondYearMonth < 10 ? '0' + secondYearMonth.toString() : secondYearMonth;
  let youData = monthly_calcs?.you
  let compareData = avgCalcs?.avg

  const formatPercent = (value, key) => {
    if (value || value === 0) {
      return (Math.round(value * 10000) / 100) + '%';
    } else {
      return '-'
    }
  };

  const formatRatio = (value) => {
    if (value || value === 0) {
      return `${value.toFixed(1)} to 1`;
    } else {
      return '-'
    }
  };

  const formatDays = (value) => {
    if (value || value === 0) {
      return `${value.toFixed(1)} days`;
    } else {
      return '-'
    }
  };

  const formatTwoDecimal = (value) => {
    if (value || value === 0) {
      return value.toFixed(2);
    } else {
      return '-'
    }
  };

  const rowFormatter = (amount, key) => {
    const ratio = ['quick_ratio', 'debt_ratio', 'operating_cash_flow_kfi', 'current_ratio', 'net_working_capital_ratio', 'debt_to_equity', 'senior_debt_to_ebitda', 'ebitda_to_annual_interest']
    const days = ['days_cash_on_hand', 'ar_days', 'ap_days']
    const money = ['net_working_capital', 'operating_expenses_net_income', 'interest_and_other_expenses', 'total_other_costs_taxes_- federal & state', 'depreciation_and_amortization', 'ebitda', 'total_ebitda']
    const twoDecimal = ['asset_turnover_ratio', 'inventory_turnover_ratio']
    const percent = ['total_revenue_growth_rate', 'net_profit', 'cash_flow_margin', 'roa', 'roe', 'roce', 'gross_profit_common_size_revenue', 'operating_profit_common_size_revenue', 'gross_profit', 'operating_profit']
    if (_.isNumber(amount)) {
      if (ratio.includes(key)) {
        return formatRatio(amount)
      } else if (days.includes(key)) {
        return formatDays(amount)
      } else if (money.includes(key)) {
        return parseMoney(amount);
      } else if (twoDecimal.includes(key)) {
        return formatTwoDecimal(amount)
      } else if (percent.includes(key)) {
        return formatPercent(amount, key)
      } else {
        return '-'
      };
    } else {
      return ''
    }
  };

  function CommonSizeArrowsHelper(valueYou, valueCompareTo, keyArrBuilder) {

    let arrow;
    if (valueYou) {
      arrow = KFIsCommonSizeArrows(valueYou, valueCompareTo, keyArrBuilder)
      if (arrow === 'better' || arrow === 'best') {
        arrow = <p className='common-size-arrow-green' style={{ margin: 0, color: 'green' }}>&#9650;</p>
      } else if (arrow === 'worse' || arrow === 'worst') {
        arrow = <p className='common-size-arrow-red' style={{ margin: 0, color: 'red' }}>&#9660;</p>
      } else {
        arrow = ''
      }
      return arrow
    }
    return arrow
  }

  const monthAndYTDRow = (row, rowValues) => {
    let firstYTDVal, secondYTDVal, firstMonthVal, secondMonthVal;
    if (!row.header) {
      firstMonthVal = rowValues?.['firstMonthVal']
      secondMonthVal = rowValues?.['secondMonthVal']
      firstYTDVal = rowValues?.['firstYTDVal']
      secondYTDVal = rowValues?.['secondYTDVal'];
    }

    let backgroundStyle = {}
    let valueCellClass = 'money-table-cell';
    let secondBackStyle = { 'backgroundColor': '#BFE0AE', 'borderLeft': '1px solid' }

    if (compareWith === 'Default:None') {
      return (
        <React.Fragment key={Math.random(89)}>
          <td className={valueCellClass} style={secondBackStyle}>
            {rowFormatter(firstMonthVal, row.key)}
          </td>
          <td style={{ 'borderLeft': '1px solid' }}></td>
          <td style={{ 'borderLeft': '1px solid' }}>
            {rowFormatter(firstYTDVal, row.key)}
          </td>
        </React.Fragment>
      )
    } else if (compareWith !== 'Default:YOY') {
      return (
        <React.Fragment key={Math.random(89)}>
          <td className={valueCellClass} style={secondBackStyle}>
            {rowFormatter(firstMonthVal, row.key)}
          </td>
          <td className={valueCellClass} style={secondBackStyle}></td>
          <td className={valueCellClass} style={secondBackStyle}>
            {rowFormatter(secondMonthVal, row.key)}
          </td>
          <td style={{ 'borderLeft': '1px solid' }}></td>
          <td style={{ 'borderLeft': '1px solid' }}>
            {rowFormatter(firstYTDVal, row.key)}
          </td>
          <td style={{ 'borderLeft': '1px solid' }}></td>
          <td style={{ 'borderLeft': '1px solid' }}>
            {rowFormatter(secondYTDVal, row.key)}
          </td>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment key={Math.random(89)}>
          <td className={valueCellClass} style={secondBackStyle}>
            {rowFormatter(firstMonthVal, row.key)}
          </td>
          <td style={{ 'borderLeft': '1px solid' }}></td>
          <td style={{ 'borderLeft': '1px solid' }}>
            {rowFormatter(secondMonthVal, row.key)}
          </td>
          <td style={{ 'borderLeft': '1px solid' }}></td>
          <td className={valueCellClass} style={secondBackStyle}>
            {rowFormatter(firstYTDVal, row.key)}
          </td>
          <td style={{ 'borderLeft': '1px solid' }}></td>
          <td style={{ 'borderLeft': '1px solid' }}>
            {rowFormatter(secondYTDVal, row.key)}
          </td>
        </React.Fragment>
      )
    }
  }

  const emptyMonthAndYTDRow = () => {
    let backgroundStyle = { 'borderBottom': '2px solid #000000' }
    let valueCellClass = 'money-table-cell';
    let secondBackStyle = { 'borderBottom': '2px solid #000000', 'backgroundColor': '#BFE0AE' }

    return (
      <React.Fragment key={Math.random(89)}>
        <td className={valueCellClass} style={secondBackStyle}></td>
        <td style={{ 'borderBottom': '2px solid #000000' }}></td>

        <td className={valueCellClass} style={secondBackStyle}>
        </td>
        <td style={backgroundStyle}></td>
        <td style={backgroundStyle}></td>
        <td style={backgroundStyle}></td>
        <td className={valueCellClass} style={secondBackStyle}>
        </td>
        <td style={backgroundStyle}></td>
        <td style={backgroundStyle}></td>
        <td style={backgroundStyle}></td>
      </React.Fragment>
    )
  }


  const buildMonthAndYTDRows = () => {
    return props.rows.map((row, i) => {
      let paddingLeft = { paddingLeft: row.paddingLeft }
      let paddingTop = row['parentKey'] ? {} : { paddingTop: '20px' }
      let borderBottom = { borderBottom: '2px solid #000000' }
      let titleStyle = row['parentKey'] ? {} : { ...paddingLeft, ...borderBottom }
      let hideRow = '';
      let zeroYears = [];
      let rowValues = null
      // hide unused rows
      const yearData = monthly_calcs?.you;
      if (!yearData) return;
      let firstMonthVal; let secondMonthVal; let firstYTDVal; let secondYTDVal;

      if (compareWith === 'Default:None') {
        let { youValues } = MonthlyKFIsValues(row, numberOfMonths, 'Default:YOY', selectedYear, previousYear, twoYearsAgo, youData, compareData, false, null)
        firstMonthVal = youValues
        firstYTDVal = calculateKFIMetric(row.key, youData, selectedYear, previousYear, ytd_months);

      } else if (compareWith === 'Default:Peers') {
        let { youValues, compareValues } = MonthlyKFIsValues(row, numberOfMonths, 'Default:Peers', selectedYear, previousYear, twoYearsAgo, youData, compareData, false, null)
        firstMonthVal = youValues
        secondMonthVal = compareValues

        firstYTDVal = calculateKFIMetric(row.key, youData, selectedYear, previousYear, ytd_months);
        secondYTDVal = calculateKFIMetric(row.key, compareData, selectedYear, previousYear, ytd_months);

      } else if (compareWith === 'Default:YOY') {
        let { youValues, compareValues } = MonthlyKFIsValues(row, numberOfMonths, 'Default:YOY', selectedYear, previousYear, twoYearsAgo, youData, compareData, false, null)
        firstMonthVal = compareValues
        secondMonthVal = youValues

        firstYTDVal = calculateKFIMetric(row.key, youData, previousYear, twoYearsAgo, ytd_months);
        secondYTDVal = calculateKFIMetric(row.key, youData, selectedYear, previousYear, ytd_months);

      } else if (compareWith && compareWith.includes('Forecast')) {
        let compareSelectedYear = props.forecastVals?.['total_revenue'] ? Object.keys(props.forecastVals['total_revenue'])[0] : null
        let { youValues, compareValues } = MonthlyKFIsValues(row, numberOfMonths, 'Default:YOY', selectedYear, previousYear, twoYearsAgo, youData, compareData, isForecast, props.forecastVals)
        firstMonthVal = youValues
        secondMonthVal = compareValues

        firstYTDVal = calculateKFIMetric(row.key, youData, selectedYear, previousYear, ytd_months);
        secondYTDVal = calculateKFIMetric(row.key, props.forecastVals, compareSelectedYear, previousYear, ytd_months, youData);
      }

      rowValues = {
        firstMonthVal: firstMonthVal?.[secondYearMonth],
        secondMonthVal: secondMonthVal?.[secondYearMonth],
        firstYTDVal: firstYTDVal,
        secondYTDVal: secondYTDVal
      }

      const youKfiMetric = firstYTDVal === '0.00' || firstYTDVal === null;
      const peersKfiMetric = secondYTDVal === '0.00' || secondYTDVal === null;

      // if (youKfiMetric && peersKfiMetric) zeroYears.push(year);
      zeroYears.length === props.yearRange.length ? hideRow = row.key : null

      if (row.key === 'ebitda') {
        titleStyle = { borderBottom: '1px solid black' }
        paddingTop['paddingTop'] = 0
      } else if (row.key === hideRow) {
        titleStyle = { display: 'none' }
      }

      let rowChecked = row.displayChart && row.checked && props.editMetrics ? <p style={{ 'margin': 0 }}>&#10004;</p> : ''

      return (
        <tr key={Math.random(89)} style={titleStyle} onClick={() => props.editMetrics ? props.handleSelectAndLayout('money', 'kfis', row.relatedCheckedKey) : null}>
          {!props.pdf ? <td>{rowChecked}</td> : null}
          <td className='table-copy' style={paddingTop}>{row.padding + row.copy}</td>
          {row['parentKey'] !== 'parent' ? monthAndYTDRow(row, rowValues) : emptyMonthAndYTDRow()}
        </tr>
      )
    })
  }

  const buildYTDRows = () => {
    return props.rows.map((row, i) => {
      let paddingLeft = { paddingLeft: row.paddingLeft }
      let paddingTop = row['parentKey'] ? {} : { paddingTop: '20px' }
      let borderBottom = { borderBottom: '2px solid #000000' }
      let titleStyle = row['parentKey'] ? {} : { ...paddingLeft, ...borderBottom }
      let hideRow = '';
      let zeroYears = [];
      const rowValues = {}
      // hide unused rows
      props.yearRange.forEach(year => {
        const yearData = monthly_calcs?.you;
        if (!yearData) return;

        const youMetric = calculateKFIMetric(row.key, youData, year, year - 1, ytd_months);
        const peersMetric = calculateKFIMetric(row.key, compareData, year, year - 1, ytd_months);

        rowValues[year] = {
          you: youMetric,
          compare: peersMetric
        }

        const youKfiMetric = youMetric === '0.00' || youMetric === null;
        const peersKfiMetric = peersMetric === '0.00' || peersMetric === null;

        if (youKfiMetric && peersKfiMetric) zeroYears.push(year);
      });

      zeroYears.length === props.yearRange.length ? hideRow = row.key : null

      if (row.key === 'ebitda') {
        titleStyle = { borderBottom: '1px solid black' }
        paddingTop['paddingTop'] = 0
      } else if (row.key === hideRow) {
        titleStyle = { display: 'none' }
      }

      let rowChecked = row.displayChart && row.checked && props.editMetrics ? <p style={{ 'margin': 0 }}>&#10004;</p> : ''

      return (
        <tr key={Math.random(89)} style={titleStyle} onClick={() => props.editMetrics ? props.handleSelectAndLayout('money', 'kfis', row.relatedCheckedKey) : null}>
          {!props.pdf ? <td>{rowChecked}</td> : null}
          <td className='table-copy' style={paddingTop}>{row.padding + row.copy}</td>
          {props.yearRange.map((year, ii) => {
            let arrowCellClass = 'common-size-arrow';
            let backgroundStyle = {}
            let commonSizeValCellClass = 'common-size-cell';
            let valueCellClass = '';
            if (ii % 2 === 0) {
              arrowCellClass += ' money-table-cell';
              backgroundStyle['backgroundColor'] = '#BFE0AE';
              commonSizeValCellClass += ' money-table-cell';
              valueCellClass = 'money-table-cell';
            }
            try {
              if (row['parentKey'] !== 'parent') {
                let arrowColumn = ''
                let youValue, avgValue;
                if (!row.header) {
                  youValue = rowValues[year]['you']
                  if (['Peers', 'Default:Peers'].includes(compareWith)) {
                    avgValue = rowValues[year]['compare'];
                    arrowColumn = CommonSizeArrowsHelper(youValue, avgValue, row.key)
                  }
                }

                return (
                  <React.Fragment key={Math.random(89)}>
                    <td className={valueCellClass} style={backgroundStyle}>
                      {rowFormatter(youValue, row.key)}
                    </td>
                    {['Peers', 'Default:Peers'].includes(compareWith)
                      ? <td className={arrowCellClass} style={{ ...backgroundStyle, 'textAlign': 'center' }}>
                        {arrowColumn}
                      </td>
                      : null}
                    {['Peers', 'Default:Peers'].includes(compareWith)
                      ? <td className={commonSizeValCellClass} style={backgroundStyle}>
                        {rowFormatter(avgValue, row.key)}
                      </td>
                      : null}
                    <td></td>
                  </React.Fragment>
                )
              } else {
                return (
                  <React.Fragment key={Math.random(89)}>
                    <td className={valueCellClass} style={{ ...backgroundStyle, 'borderBottom': '2px solid #000000' }}></td>
                    {['Peers', 'Default:Peers'].includes(compareWith) ? <td className={arrowCellClass} style={{ ...backgroundStyle, 'borderBottom': '2px solid #000000' }}></td> : null}
                    {['Peers', 'Default:Peers'].includes(compareWith) ? <td className={commonSizeValCellClass} style={{ ...backgroundStyle, 'borderBottom': '2px solid #000000' }}></td> : null}
                    <td style={{ 'borderBottom': '2px solid #000000' }}></td>
                  </React.Fragment>
                )
              }
            } catch { return <td key={Math.random(89)}></td>; }
          })}
        </tr>
      )
    })
  };

  const buildRows = () => {
    if (reportPeriod === 'CM + YTD') {
      return buildMonthAndYTDRows();
    } else {
      return buildYTDRows()
    }
  }

  const buildHeader = () => {
    if (reportPeriod === 'CM + YTD') {
      if (compareWith === 'Default:YOY') {
        return (
          <thead>
            <tr>
              {!props.pdf ? <td className='edit-metrics-cell' onClick={() => props.handleEditMetrics()}>{props.editMetrics ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td> : null}
              <td></td>
              <td colSpan={'1'} className='' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`${monthNames[firstYearMonth]} ${previousYearEndDigits}`}</td>
              <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>
              <td colSpan={'1'} style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`${monthNames[secondYearMonth]} ${selectedYearEndDigits}`}</td>
              <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>
              <td colSpan={'1'} className='' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`YTD ${previousYearEndDigits}`}</td>
              <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>
              <td colSpan={'1'} style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`YTD ${selectedYearEndDigits}`}</td>
            </tr>
            <tr>
              {!props.pdf ? <td style={{ 'borderBottom': '1px solid'}}></td> : null}
              <td style={{ 'borderBottom': '1px solid'}}></td>
              <td className='common-size-cell' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>You</td>
              <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>
              <td className='common-size-cell' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>You</td>
              <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>
              <td className='common-size-cell' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>You</td>
              <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>
              <td className='common-size-cell' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>You</td>
            </tr>
          </thead>
        )
      } else {
        let compareTitle = null;
        let cellStyle = {}
        let cellClass = ''
        if (compareWith === 'Default:Peers') {
            compareTitle = 'Peers'
        } else if (compareWith && compareWith.includes('Forecast')) {
            compareTitle = props.monthlyCompareWithTitle
        }

        return (
          <thead>
            <tr>
              {!props.pdf ? <td className='edit-metrics-cell' onClick={() => props.handleEditMetrics()}>{props.editMetrics ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td> : null}
              <td></td>
              {compareWith === 'Default:None' ? null : <td colSpan={compareWith !== 'Default:None' ? '3' : '1'} className='' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`${monthNames[secondYearMonth]} ${selectedYearEndDigits}`}</td>}
              {compareWith === 'Default:None' ? null : <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>}
              {compareWith === 'Default:None' ? <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`${monthNames[secondYearMonth]} ${selectedYearEndDigits}`}</td> : null}
              {compareWith === 'Default:None' ? <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td> : null}
              <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }} colSpan={compareWith !== 'Default:None' ? '3' : '1'}>{`YTD ${selectedYearEndDigits}`}</td>
            </tr>
            <tr>
              {!props.pdf ? <td style={{ 'borderBottom': '1px solid'}}></td> : null}
              <td style={{ 'borderBottom': '1px solid'}}></td>
              <td className='common-size-cell' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>You</td>
              {compareWith === 'Default:None' ? <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td> : <td className='common-size-cell' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>}
              {compareWith === 'Default:None' ? null : <td className='common-size-cell' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{compareTitle}</td>}
              {compareWith === 'Default:None' ? null : <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>}
              <td className='common-size-cell' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>You</td>
              {compareWith === 'Default:None' ? null : <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>}
              {compareWith === 'Default:None' ? null : <td className='common-size-cell' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{compareTitle}</td>}
            </tr>
          </thead>
        )
      }
              
    } else {
      return (
        <thead>
          <tr>
            {!props.pdf ? <td className='edit-metrics-cell' onClick={() => props.handleEditMetrics()}>{props.editMetrics ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td> : null}
            <td></td>
            <td colSpan={compareWith === 'Peers' ? '3' : '1'} className='common-size-cell money-table-cell' style={{ backgroundColor: '#BFE0AE' }}>{`YTD ${clientFirstYearMonth}/${previousYear}`}</td>
            <td></td>
            <td colSpan={compareWith === 'Peers' ? '3' : '1'}>{`YTD ${clientSecondYearMonth}/${selectedYear}`}</td>
          </tr>
          <tr>
            {!props.pdf ? <td></td> : null}
            <td></td>
            <td className='common-size-cell money-table-cell' style={{ backgroundColor: '#BFE0AE' }}>You</td>
            {compareWith === 'Peers' ? <td className='common-size-cell money-table-cell' style={{ backgroundColor: '#BFE0AE' }}></td> : null}
            {compareWith === 'Peers' ? <td className='common-size-cell money-table-cell' style={{ backgroundColor: '#BFE0AE' }}>Peers</td> : null}
            <td></td>
            <td className='common-size-cell'>You</td>
            {compareWith === 'Peers' ? <td className='common-size-cell'></td> : null}
            {compareWith === 'Peers' ? <td className='common-size-cell'>Peers</td> : null}
          </tr>
        </thead>
      )
    }
  }

  const buildYTDKFI = () => {
    if (props.pdf) {
      let pageViewClass = 'portrait-view'
      // let pageViewClass = 'landscape-view'
      let clientNames = props.realName ? `${props.realName} / ${props.clientName}` : props.clientName
      const tabName = (props.tabName || "KFI's" || '').trim().toLowerCase();
      const title = "KFI's".toLowerCase();
      let reportTitle = tabName.includes(title) ? props.tabName || "KFI's" : `${props.tabName}, Cash Flow`;
      let naicsCode = finalFilters.code;
      let dataType = finalFilters.datatype;
      let revenueBand = finalFilters.revenue_band;
      let region = finalFilters.region;
      let numOfDocs = finalFilters.number_of_pros || 'All'

      const compareParts = finalFilters.compare_with.split(':');
      let compare = compareParts.length > 1 ? compareParts.slice(1).join(':').trim() : finalFilters.compare_with;
      let filtersTitle = `NAICS: ${naicsCode}, Data Type: ${dataType}, Revenue: ${revenueBand}, Region: ${region}, Report Period: ${reportPeriod}, Compare with: ${compare}`;

      return (
        <div className={pageViewClass}>
          <div className='money-pdf-portrait'>
            <div>
              <div>
                <p className='report-annual-title'>{`${reportTitle}, ${clientNames}`}</p>
                <p className='report-filters-title'>{filtersTitle}</p>
              </div>
              <div className='money-pdf-table-div'>
                <table className='report-table sheets' id='kfi-table-ytd-pdf'>
                  {buildHeader()}
                  <tbody>
                    {buildRows()}
                    <tr><td className='footer-cell'><i>{numberCompare}</i></td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <p className='pdf-disclaimer-text'>{`These financial statements have been prepared by ${props.firmName}, and have not been subjected to an audit or review or compilation engagement, and no assurance is provided on them. These financial statements are intended for management’s internal use only. Substantially all disclosures omitted.`}</p>
          </div>
        </div>
      )
    } else {
      return (
        <div className='money-report-card monthly-sheet'>
          <div className='money-report-container'>
            <table className='report-table sheets' id='kfi-table-ytd'>
              {buildHeader()}
              <tbody>
                {buildRows()}
              </tbody>
              <tfoot>
                <tr><td><i>{numberCompare}</i></td></tr>
              </tfoot>
            </table>
          </div>
        </div>
      )
    }
  }

  return buildYTDKFI()
};

export default MoneyYTDKFI;